// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__8dfuE","title":"NotFound_title__dkgbu"};